<div class="govuk-grid-row">


  <div class="govuk-grid-column-one-third">
    <h2 class="govuk-heading-l">Snippet Index</h2>

    <div class="govuk-form-group">
      <label class="govuk-label" for="filter">
        Filter
      </label>
      <input class="govuk-input" id="filter" name="filter" type="text" [formControl]="textFilter">
    </div>

    <div class="govuk-form-group">
      <div class="govuk-checkboxes__item">
        <input class="govuk-checkboxes__input" id="invalid-only" name="invalid-only" type="checkbox" [formControl]="errorFilter">
        <label class="govuk-label govuk-checkboxes__label" for="invalid-only">
          Invalid snippets only
        </label>
      </div>

      <div class="govuk-checkboxes__item">
        <input class="govuk-checkboxes__input" id="advice-links" name="advice-links" type="checkbox" [formControl]="adviceLinksOption">
        <label class="govuk-label govuk-checkboxes__label" for="advice-links">
          Advice Links
        </label>
      </div>

      <div class="govuk-checkboxes__item">
        <input class="govuk-checkboxes__input" id="snippet-id" name="snippet-id" type="checkbox" [formControl]="snippetIdOption">
        <label class="govuk-label govuk-checkboxes__label" for="snippet-id">
          Snippet Id
        </label>
      </div>
    </div>


    <div class="govuk-caption-m" [ngSwitch]="results.length">
      <span *ngSwitchCase="0">No snippets found</span>
      <span *ngSwitchCase="1">One snippet found</span>
      <span *ngSwitchDefault>{{results.length}} snippets found</span>
    </div>
    <br/>
  </div>

  <div class="govuk-grid-column-two-thirds">

    <div *ngFor="let result of results">

      <div class="govuk-heading-m">{{result.snippet.description}}</div>

      <div class="govuk-heading-m monospace" *ngIf="showSnippetId">{{result.snippet.id}}</div>

      <div *ngIf="result.snippet.errors" class="govuk-body-s errors">
        <ng-container *ngFor="let error of result.snippet.errors">
          <i class="fa fa-exclamation-triangle"></i>
          <span>{{error}}</span>
        </ng-container>
      </div>


      <div class="govuk-body-s" [innerHTML]="result.snippet.data"></div>

      <div class="links govuk-inset-text" *ngIf="showAdviceLinks">
        <ul class="govuk-list govuk-!-font-size-14" >
          <li *ngFor="let item of result.links">
            <a class="theme-link left-border" [routerLink]="item.href" *ngIf="item.href; else invalidPath">
              {{item.text}}
            </a>
            <ng-template #invalidPath>
              <a>{{item.text}}</a>
            </ng-template>
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>
